import styles from "./NavButton.module.css";

function NavButton(props) {
    const label = props.navButtonLabel;

    return (
        <button className={styles.navigationButton}>{label}</button>
    )
}
export default NavButton;